import React, { useState } from 'react'
import BossDialog from '../../components/BossDialog'
import { useTranslation } from '../../locale/useTranslation';
import { EditPageHeader } from '../../components/EditPageHeader';
import { useEffect } from 'react';
import { ENTITYNAME, LOCALSTORAGE_KEY, LOGEVENT, MODULE, NOTIFICATION_TOPIC, OTT_POSTER_TYPE, TOAST_TYPES } from '../../framework/constant/constant';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import * as API from '../../framework/API/api';
import { ImageBrowser } from '../../framework/forms/helpercomponents/selectFile/ImageBrowser';
import { utility } from '../../framework/utility/utilityProvider';
import MyMultiSelect from '../../components/MyMultiSelect';
import CollectionSelection from '../../framework/forms/CollectionSelection';
import ActionButton from '../../framework/forms/helpercomponents/buttons/ActionButton';
import { useNavigate } from 'react-router-dom';
import OttAssetCollectionSelection from '../../framework/OTT/OttAssetCollectionSelection';
import SubscriberCollectionSelection from '../../framework/forms/SubscriberCollectionSelection';
import ToastNotification from "../../components/ToastNotification";

const NotificationManager = () => {

    const lang = useTranslation();
    const navigate = useNavigate();
    const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);

    const blankDataItem = {
        title: "",
        group: { _id: NOTIFICATION_TOPIC.All, Description: utility.getKeyByValue(NOTIFICATION_TOPIC, NOTIFICATION_TOPIC.All) },
        image: "",
        segments: [],
        languages: [],
        regions: [],
        body: "",
        asset: [],
        user: []
    }
    const [dataItem, setDataItem] = useState(blankDataItem);
    const [imageFiles, setImageFiles] = useState(new Set());
    const [groups, setGroups] = useState([]);
    const [regions, setRegions] = useState([]);
    const [segments, setSegments] = useState([]);
    const [languages, setLanguages] = useState([]);
    const [showUsers, setShowUsers] = useState(false);
    const [showAsset, setShowAsset] = useState(false);

    useEffect(() => {
        loadCombo();
    }, [])

    const loadCombo = async () => {
        let groupRes = Object.keys(NOTIFICATION_TOPIC).map((x) => {
            return {
                _id: NOTIFICATION_TOPIC[x],
                Description: x
            }
        })
        setGroups(groupRes);
        let regionsRes = await API.getDataLookup(ENTITYNAME.Region, { query: ["Archive", "!=", true], sort: { Description: 1 } });
        setRegions(regionsRes.data)
        let segmentRes = await API.getDataLookup(ENTITYNAME.OttSegment, { query: ["Archive", '!=', true], sort: { Description: 1 } });
        setSegments(segmentRes.data);
        let languageRes = await API.getDataLookup(ENTITYNAME.Language, { query: ["Archive", '!=', true], sort: { Description: 1 } });
        setLanguages(languageRes.data);
    }

    const onChange = (e) => {
        const { name, type, files, value } = e.target || {};
        if (name == 'image' && e.target?.files) {
            if (type === 'file' && files?.length > 0) {
                setImageFiles(files[0]);
                setDataItem({ ...dataItem, image: files[0] ? URL.createObjectURL(files[0]) : "" });
            } else {
                setImageFiles(new Set());
                setDataItem({ ...dataItem, image: "" });
            }
        }
        else {
            setDataItem({ ...dataItem, [name]: value });
        }
    };

    const handleSelectedImage = (dataList) => {
        setImageFiles(null);
        setDataItem({ ...dataItem, image: dataList[0].image });
    };

    const isValid = () => {
        if (!dataItem.group || Object.keys(dataItem.group).length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_select_group_error_message}` });
            return false;
        }

        if (dataItem.group?._id === NOTIFICATION_TOPIC.Language && (!dataItem.languages || dataItem.languages.length === 0)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_select_language_error_message}` });
            return false;
        }

        if (dataItem.group?._id === NOTIFICATION_TOPIC.Region && (!dataItem.regions || dataItem.regions.length === 0)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_select_regions_error_message}` });
            return false;
        }

        if (dataItem.group?._id === NOTIFICATION_TOPIC.Segment && (!dataItem.segments || dataItem.segments.length === 0)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_select_segment_error_message}` });
            return false;
        }

        if (dataItem.group?._id === NOTIFICATION_TOPIC.User && (!dataItem.user || Object.keys(dataItem.user).length === 0)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_select_user_error_message}` });
            return false;
        }

        if (dataItem.title == "" || dataItem.title == undefined) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_title_error_message}` });
            return false;
        }
        if (!dataItem.image || dataItem.image === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_image_url_error_message });
            return false;
        }
        return true;
    }

    const handleSubmit = async () => {

        if (!isValid()) return;

        let imageUrl = dataItem.image;

        if (!dataItem.asset && imageFiles?.size > 0) {
            let resUrl = await API.uploadImage(imageFiles);
            if (!resUrl.success) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.upload_fail_error_message });
                return;
            }
            imageUrl = resUrl.data;
        }

        let topicValue = "";
        const removeSpaceToUnderscroe = (value) => {
            if (!value || value == "") return;
            return value.replace(/ /g, "_");
        };

        if (dataItem.group?._id === NOTIFICATION_TOPIC.All) {
            topicValue = dataItem.group?.Description;
        } else if (dataItem.group?._id === NOTIFICATION_TOPIC.User && Object.keys(dataItem.user).length > 0) {
            topicValue = dataItem.user?.Name
        } else if (dataItem.group?._id === NOTIFICATION_TOPIC.Region && dataItem.regions?.length > 0) {
            topicValue = dataItem.regions.map(r => removeSpaceToUnderscroe(r.Description));
        } else if (dataItem.group?._id === NOTIFICATION_TOPIC.Language && dataItem.languages?.length > 0) {
            topicValue = dataItem.languages.map(l => removeSpaceToUnderscroe(l.Description));
        } else if (dataItem.group?._id === NOTIFICATION_TOPIC.Segment && dataItem.segments?.length > 0) {
            topicValue = dataItem.segments.map(s => removeSpaceToUnderscroe(s.Description));
        } else {
            topicValue = dataItem.group?.Description || "";
        }

        let payload = {
            topic: topicValue,
            title: dataItem.title,
            body: dataItem.body,
            image: imageUrl
        };

        if (dataItem?.asset && dataItem?.asset?._id) {
            payload.params = { assetId: dataItem.asset._id };
        }
        console.log(payload);
        const res = await API.sendToTopic(payload);
        if (res.success) {
            await API.saveData(ENTITYNAME.NOTIFICATION_HISTORY, payload);
            API.SaveLogs({ event: res.message === "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.NOTIFICATION_MANAGER, data: payload, message: res.message});
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    };

    const handleUsersSelect = (dataUser) => {
        if (dataUser?.length > 0) {
            setDataItem({ ...dataItem, user: dataUser[0] });
        }
    };

    const fillAssetData = (data) => {
        if (!data || Object.keys(data).length === 0) return;

        let imageUrl = (data?.Posters?.lenght > 0 && data?.Posters.some(p => p?.OttPosterType?.SID === OTT_POSTER_TYPE.Landscape)) ?  utility.getPosterUrl(data?.Posters, OTT_POSTER_TYPE.Landscape)
        : data?.Posters[0]?.Url;

        setDataItem({ ...dataItem, asset: { ...data, Title: data?.Title }, title: data?.Title, body: data?.Description, image: imageUrl});
       
    };
    
    const handleAssetsSelect = (dataList) => {
        if (!dataList || dataList.length === 0) return;
        let assets = utility.getDataWithDisplayValueByLang(dataList, ["Title", "Description", "Posters"], company.Language)
        fillAssetData(assets[0]);
    };
    
    return (
        <BossDialog title={lang.notification_manager_dialog_header} onClose={() => navigate(-1)} width={"900px"}>
            <EditPageHeader title={""} showTitle={false} saveButtonTitle={lang.notification_send_label} onSubmit={handleSubmit} onCancel={() => navigate(-1)} />
            <div className='row mt-2'>
                <div className='col-6'>
                    <label>{lang.group_label} *</label>
                    <DropDownList
                        name='group'
                        data={groups}
                        textField='Description'
                        dataItemKey='_id'
                        value={dataItem.group}
                        onChange={onChange}
                        className='form-control form-control-sm'
                        style={{ backgroundColor: "white" }}
                    />
                </div>
                {dataItem?.group?._id === NOTIFICATION_TOPIC.User && (
                    <div className='col-6'>
                        <label>{lang.user_label} *</label>
                        <div className='d-flex'>
                            <input
                                name="user"
                                type="text"
                                className="form-control form-control-sm"
                                value={dataItem.user.Name}
                                onChange={onChange}
                                disabled={true}
                            />
                            <ActionButton style={{ height: "30px" }} btnColor="success" title={lang.select_button_tooltip} name="..." onClick={() => setShowUsers(true)}/>
                            <ActionButton style={{ height: "30px" }} btnColor="danger" title={lang.remove_filtter_button_tooltip} name="" icon="xmark" onClick={() => setDataItem(prev => ({ ...prev, user: [] }))}/>
                        </div>
                    </div>
                )}
                {dataItem?.group?._id === NOTIFICATION_TOPIC.Region && (
                    <div className='col-6'>
                        <label>{lang.region_label} *</label>
                        <MyMultiSelect
                            name='regions'
                            data={regions}
                            textField='Description'
                            dataItemKey='_id'
                            value={dataItem.regions}
                            onChange={onChange}
                            className='form-control form-control-sm'
                            style={{ backgroundColor: "white" }}
                        />
                    </div>
                )}
                {dataItem?.group?._id === NOTIFICATION_TOPIC.Segment && (
                    <div className='col-6'>
                        <label>{lang.segment_label} *</label>
                        <MyMultiSelect
                            style={{ backgroundColor: "white" }}
                            className='form-control form-control-sm'
                            data={segments}
                            name='segments'
                            textField='Description'
                            dataItemKey='_id'
                            value={dataItem.segments}
                            onChange={onChange}
                        />
                    </div>
                )}
                {dataItem?.group?._id === NOTIFICATION_TOPIC.Language && (
                    <div className='col-6'>
                        <label>{lang.language_label} *</label>
                        <MyMultiSelect
                            style={{ backgroundColor: "white" }}
                            className='form-control form-control-sm'
                            data={languages}
                            name='languages'
                            textField='Description'
                            dataItemKey='_id'
                            value={dataItem.languages}
                            onChange={onChange}
                        />
                    </div>
                )}
                <div className={dataItem?.group?._id === NOTIFICATION_TOPIC.All ? 'col-6' : 'col-6 mt-2'}>
                    <label>{lang.select_asset_label}</label>
                    <div className='d-flex'>
                        <input
                            name="asset"
                            type="text"
                            className="form-control form-control-sm"
                            value={dataItem?.asset?.Title ?? ''}
                            onChange={onChange}
                            disabled={true}
                        />
                        <ActionButton style={{ height: "30px" }} btnColor={"success"} title={lang.select_button_tooltip} name={"..."} onClick={() => setShowAsset(true)} />
                        <ActionButton style={{ height: "30px" }} btnColor={"danger"} title={lang.remove_filtter_button_tooltip} name={""} icon={"xmark"} onClick={() => setDataItem(prev => ({ ...prev, asset: null, title: "", body: "", image: "" }))} />
                    </div>
                </div>
                <div className='col-6 mt-2'>
                    <label>{lang.title_label} *</label>
                    <input type='text' name='title' value={dataItem.title} onChange={onChange} className='form-control form-control-sm' />
                </div>
            </div>
            <div className='row mt-2'>
                <div className='col-12'>
                    <label>{lang.body_label}</label>
                    <textarea className="form-control form-control-sm" name="body" value={dataItem.body} onChange={onChange} style={{height: "100px"}}/>
                </div>
            </div>
            <div className='row mt-3'>
                <div className="col-6">
                    <label>{lang.image_url_label} *</label>
                    <ImageBrowser name={'image'} value={dataItem.image} onChange={onChange} setSelectedImage={handleSelectedImage} hidePosterLibrary={false} />
                </div>
                <div className='col-6'>
                <img src={dataItem.image} width="50px" style={{margingTop: "12px"}}/>
                </div>
            </div>
            {showUsers &&
                <SubscriberCollectionSelection addButtonTitle={lang.select_button_text} title={lang.user_select_dialog_header} setDataList={handleUsersSelect} entityname={ENTITYNAME.Subscriber} closeForm={() => setShowUsers(false)} mode={'single'} width={"60vw"} />
            }
            {showAsset &&
                <OttAssetCollectionSelection addButtonTitle={lang.select_button_text} title={lang.asset_select_dialog_header} setDataList={handleAssetsSelect} entityname={ENTITYNAME.OttAsset} closeForm={() => setShowAsset(false)} mode={'single'} width={"60vw"} />
            }
        </BossDialog>
    )
}

export default NotificationManager